import React from 'react';
import Logo from "./../img/logo.svg";

function Home() {
    return (
        <React.Fragment>
            <div className="flex flex-col items-center justify-center min-h-screen bg-primary text-center p-4">
                <div className="flex items-center space-x-4">
                    <img src={Logo} alt="Logo" className="w-24 h-24"/>
                    <h1 className="text-4xl font-bold text-color-secondary">Digitally<span className="text-color-primary">Woven</span></h1>
                </div>
                <p className="text-lg text-color-primary mt-10">🇧🇪-based digital consultancy with expertise in web technologies, PIM and DAM.</p>
                <a href="mailto:hello@digitallywoven.com"
                   className="text-color-primary mt-10 text-xl font-semibold hover:underline">
                    hello@digitallywoven.com
                </a>
            </div>
        </React.Fragment>
    );
}

export default Home;